// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * Pre-bundled Fluent UI icon pairs (filled + regular) used throughout the application.
 *
 * See full catalog at https://react.fluentui.dev/?path=/docs/icons-catalog--docs.
 */
import {
  ArrowExitFilled,
  ArrowExitRegular,
  BeakerFilled,
  BeakerRegular,
  CodeFilled,
  CodeRegular,
  CubeFilled,
  CubeRegular,
  DesignIdeasFilled,
  DesignIdeasRegular,
  FlowFilled,
  FlowRegular,
  FolderOpenFilled,
  FolderOpenRegular,
  LeafOneFilled,
  LeafOneRegular,
  LinkFilled,
  LinkRegular,
  OpenFilled,
  OpenRegular,
  OrganizationHorizontalFilled,
  OrganizationHorizontalRegular,
  PanelLeftContractFilled,
  PanelLeftContractRegular,
  PanelLeftExpandFilled,
  PanelLeftExpandRegular,
  PanelRightContractFilled,
  PanelRightContractRegular,
  PanelRightExpandFilled,
  PanelRightExpandRegular,
  PersonFilled,
  PersonRegular,
  PersonFeedbackFilled,
  PersonFeedbackRegular,
  SearchFilled,
  SearchRegular,
  ShareFilled,
  ShareRegular,
  TreeDeciduousFilled,
  TreeDeciduousRegular,
  TreeEvergreenFilled,
  TreeEvergreenRegular,
  WeatherMoonFilled,
  WeatherMoonRegular,
  WeatherSunnyFilled,
  WeatherSunnyRegular,
  bundleIcon
} from "@fluentui/react-icons";

export const ArrowExit = bundleIcon(ArrowExitFilled, ArrowExitRegular);
export const Beaker = bundleIcon(BeakerFilled, BeakerRegular);
export const Code = bundleIcon(CodeFilled, CodeRegular);
export const Cube = bundleIcon(CubeFilled, CubeRegular);
export const DesignIdeas = bundleIcon(DesignIdeasFilled, DesignIdeasRegular);
export const Flow = bundleIcon(FlowFilled, FlowRegular);
export const FolderOpen = bundleIcon(FolderOpenFilled, FolderOpenRegular);
export const LeafOne = bundleIcon(LeafOneFilled, LeafOneRegular);
export const Link = bundleIcon(LinkFilled, LinkRegular);
export const Open = bundleIcon(OpenFilled, OpenRegular);
export const OrganizationHorizontal = bundleIcon(
  OrganizationHorizontalFilled,
  OrganizationHorizontalRegular
);
export const PanelLeftContract = bundleIcon(
  PanelLeftContractFilled,
  PanelLeftContractRegular
);
export const PanelLeftExpand = bundleIcon(
  PanelLeftExpandFilled,
  PanelLeftExpandRegular
);
export const PanelRightContract = bundleIcon(
  PanelRightContractFilled,
  PanelRightContractRegular
);
export const PanelRightExpand = bundleIcon(
  PanelRightExpandFilled,
  PanelRightExpandRegular
);
export const Person = bundleIcon(PersonFilled, PersonRegular);
export const PersonFeedback = bundleIcon(
  PersonFeedbackFilled,
  PersonFeedbackRegular
);
export const Search = bundleIcon(SearchFilled, SearchRegular);
export const Share = bundleIcon(ShareFilled, ShareRegular);
export const TreeDeciduous = bundleIcon(
  TreeDeciduousFilled,
  TreeDeciduousRegular
);
export const TreeEvergreen = bundleIcon(
  TreeEvergreenFilled,
  TreeEvergreenRegular
);
export const WeatherMoon = bundleIcon(WeatherMoonFilled, WeatherMoonRegular);
export const WeatherSunny = bundleIcon(WeatherSunnyFilled, WeatherSunnyRegular);
